export default "__VITE_ASSET__4bac853c__"